import pluralize from "pluralize";
import { Button } from "reactstrap";

export const CreateButton = ({ onClick, style }) => (
  <Button className="create-action-button" onClick={onClick}>
    <p className="m-0">
      <i className="mdi mdi-plus pr-1"></i>Add Action
    </p>
    <p className="m-0" style={{ fontSize: 12 }}>
      Add a new action to the workflow
    </p>
  </Button>
);

export const WorkflowLine = () => <div className="workflow-line"></div>;

export const WorkflowErrors = ({ workflowErrors }) => {
  const length = Object.keys(workflowErrors).length;

  return (
    <div
      className="bg-danger ml-4 p-2 text-center text-white font-weight-600 shadow-lg rounded"
      style={{
        width: 200,
        position: "sticky",
        zIndex: 10,
        bottom: 20,
        border: "2px solid var(--dark)",
      }}
    >
      {length} {pluralize("Error", length)} Detected
    </div>
  );
};
